import React, { memo, useCallback, useEffect, useMemo, useState } from 'react'

import { Icon, Search, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'
import { debounce } from 'throttle-debounce'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const icon = <Icon notSpaced svgComponent={Search} color="dark" size="small" />

const SEARCH_DEBOUNCE_MS = 500

function SearchField({ onSearch }) {
  const t = useTranslation()
  const [search, setSearch] = useState('')

  const debouncedSearch = useMemo(
    () => debounce(SEARCH_DEBOUNCE_MS, value => onSearch((value ?? '').trim())),
    [onSearch],
  )

  useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch])

  const handleChange = useCallback((e) => {
    const nextValue = e.target.value
    setSearch(nextValue)
    debouncedSearch(nextValue)
  }, [debouncedSearch])

  const handleKeyDown = useCallback((e) => {
    if (e.key !== 'Enter') {
      return
    }
    e.preventDefault()
    debouncedSearch.cancel()
    onSearch((e?.target?.value ?? '').trim())
  }, [debouncedSearch, onSearch])

  return (
    <TextInput
      id="three-d-model-picker-search"
      placeholder={t('threeDModelPicker.searchPlaceholder')}
      aria-label={t('threeDModelPicker.searchPlaceholder')}
      value={search}
      size="small"
      wrapperClassName="three-d-model-picker__search"
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      leadIcon={icon}
      isPilot
    />
  )
}

SearchField.propTypes = {
  onSearch: func.isRequired,
}

export default memo(SearchField)
